import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_CONFIG = {
  slug: "chouette-apprentissage",
  app_name: "Chouette Apprentissage",
  tagline: "Les devoirs deviennent chouettes",
  companion_name: "Chouette",
  welcome_message: "Bonjour ! Je suis Chouette, ta compagne de devoirs. On commence par quoi ?",
  app_store_url: "",
  play_store_url: "",
  support_email: "support@chouetteapprentissage.com",
  site_url: "https://chouetteapprentissage.com",
};

export const useAppConfig = () => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  useEffect(() => {
    axios
      .get(`${API}/apps/chouette-apprentissage/config`)
      .then((r) => setConfig({ ...DEFAULT_CONFIG, ...r.data }))
      .catch(() => {});
  }, []);
  return config;
};

export default useAppConfig;